import {CourseType} from "@/types/CourseType";
import {TrainingAudience} from "@/types/TrainingAudience";

export default class SearchParameters {

    firstItem!: number;
    itemCount!: number;
    fromDate!: Date|null;
    toDate!: Date|null;
    newlyAdded!: boolean;
    lastCall!: boolean;
    types: CourseType[] = [];
    trainingAudiences: TrainingAudience[] = [];
    topics: number[] = [];
    civilianTrainingAreas: number[] = [];
    militaryDisciplines: number[] = [];
    networks: number[] = [];
    trainingInstitutions: number[] = [];
    location!: string|null;
    keywords!: string|null;


    public static getNew(): SearchParameters {

        const result: SearchParameters = new SearchParameters();
        result.firstItem = 0;
        result.itemCount = 20;
        result.newlyAdded = false;
        result.lastCall = false;
        result.fromDate = null;
        result.toDate = null;
        result.location = null;
        result.keywords = null;

        return result;

    }

    public static fromResponse(data: any): SearchParameters {

        const result: SearchParameters = new SearchParameters();

        if (data.firstItem != undefined) {
            result.firstItem = data.firstItem;
        }

        if (data.itemCount != undefined) {
            result.itemCount = data.itemCount;
        }

        if (data.fromDate != undefined) {
            result.fromDate = data.fromDate;
        }

        if (data.toDate != undefined) {
            result.toDate = data.toDate;
        }

        if (data.newlyAdded != undefined) {
            result.newlyAdded = data.newlyAdded;
        }

        if (data.lastCall != undefined) {
            result.lastCall = data.lastCall;
        }

        if (data.location != undefined) {
            result.location = data.location;
        }

        if (data.types != undefined && Array.isArray(data.types)) {
            data.types.forEach((item: any) => result.types.push(CourseType[item as keyof typeof CourseType]));
        }

        if (data.trainingAudiences != undefined && Array.isArray(data.trainingAudiences)) {
            data.trainingAudiences.forEach((item: any) => result.trainingAudiences.push(TrainingAudience[item as keyof typeof TrainingAudience]));
        }

        if (data.topics != undefined && Array.isArray(data.topics)) {
            data.topics.forEach((item: any) => result.topics.push(item));
        }

        if (data.civilianTrainingAreas != undefined && Array.isArray(data.civilianTrainingAreas)) {
            data.civilianTrainingAreas.forEach((item: any) => result.civilianTrainingAreas.push(item));
        }

        if (data.networks != undefined && Array.isArray(data.networks)) {
            data.networks.forEach((item: any) => result.networks.push(item));
        }

        if (data.trainingInstitutions != undefined && Array.isArray(data.trainingInstitutions)) {
            data.trainingInstitutions.forEach((item: any) => result.trainingInstitutions.push(item));
        }

        if (data.keywords != undefined) {
            result.keywords = data.keywords;
        }

        return result;

    }




}